module.exports = __webpack_public_path__ + "static/img/role.1c013a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/ch/role.png
// module id = QmPq
// module chunks = 7